import RecetteList from '../components/RecettesList'

function RecettePouletCurry() {
  return (
    <>
        <RecetteList/>
    </>
  );
}

export default RecettePouletCurry;